<template>
  <v-container fluid>
    <v-row>
      <v-col cols="2">
        <v-text-field v-model="fecha1" label="Desde" outlined dense hide-details type="date" />
      </v-col>

      <v-col cols="2">
        <v-text-field v-model="fecha2" label="Hasta" outlined dense hide-details type="date" />
      </v-col>

      <v-col cols="auto" class="d-flex align-center">
        <v-btn color="primary" :disabled="loading" @click="descargarZipFirmados">
          Descargar ZIP
        </v-btn>
        <v-progress-circular v-if="loading" indeterminate color="primary" class="ml-4" />
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" timeout="4000" color="blue" multi-line elevation="24" outlined top right>
      <v-icon class="mr-2">fa-solid fa-circle-info</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "DescargaFirmadosPorFechas",
  data() {
    return {
      fecha1: "",
      fecha2: "",
      loading: false,
      snackbar: false,
      snackbar_text: "",
    };
  },
  methods: {
    _filenameFromDisposition(disposition, fallback) {
      if (!disposition) return fallback;
      const m = /filename\*?=(?:UTF-8'')?"?([^\";]+)"?/i.exec(disposition);
      if (m && m[1]) { try { return decodeURIComponent(m[1].replace(/\"/g, "")); } catch { return m[1]; } }
      return fallback;
    },

    _toYMD(input) {
      if (typeof input === "string" && /^\d{4}-\d{2}-\d{2}$/.test(input)) return input;
      const d = new Date(input);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },

    async descargarZipFirmados() {
      if (!this.fecha1 || !this.fecha2) {
        this.snackbar_text = "Debe establecer ambas fechas (desde y hasta).";
        this.snackbar = true; return;
      }
      if (this.fecha1 > this.fecha2) {
        this.snackbar_text = "La fecha 'Desde' no puede ser mayor que 'Hasta'.";
        this.snackbar = true; return;
      }

      const end = new Date(this.fecha2);
      end.setDate(end.getDate() + 1);

      const fecha1 = this._toYMD(this.fecha1);   
      const fecha2 = this._toYMD(end);                

      const id_emp = this.$store?.state?.emp?.id_empresa;
      if (!id_emp) {
        this.snackbar_text = "Falta id_empresa en el store.";
        this.snackbar = true; return;
      }

      const payload = {
        origen: "sqlserver",            
        id_emp: this.$store.state.emp.id_empresa,
        nom_base: "sqlserver",
        fecha1: this.fecha1,   
        fecha2,     
      };

      try {
           this.loading = true;

        const resp = await axios.post(
          "/api/ServicioRecepciones/DescargarArchivosFirmados",
          payload,
          { responseType: "blob", validateStatus: s => s >= 200 && s < 600, timeout: 0 }
        );

        if (resp.status === 204) {
          this.snackbar_text = resp.headers?.respuesta || "No hay documentos en ese rango de fecha.";
          this.snackbar = true; return;
        }
        if (resp.status === 404) {
          this.snackbar_text = "Datos a validar no coinciden (404).";
          this.snackbar = true; return;
        }
        if (resp.status !== 200) {
          this.snackbar_text = `Error al descargar ZIP: ${resp.status}`;
          this.snackbar = true; return;
        }

        const cd = resp.headers["content-disposition"] || resp.headers["Content-Disposition"];
        const rango = `${this.fecha1.replace(/-/g, "")}-${this.fecha2.replace(/-/g, "")}`;
        const filename = this._filenameFromDisposition(cd, `Firmados_${rango}.zip`);

        const blob = new Blob([resp.data], { type: "application/octet-stream" });
        if (window.navigator?.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(a.href);
        }
      } catch (err) {
        this.snackbar_text = `Fallo de red/servidor: ${err?.message || err}`;
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    }


},
};
</script>


<style scoped>
.v-btn {
  min-width: 220px;
}
</style>
